import React from "react";
import { toast } from "react-toastify";

const MembershipToast = ({ onBack }) => {
  const handleOk = () => {
    toast.dismiss("membership-toast"); // ✅ reliably closes this specific toast
    if (onBack) onBack(); // navigate back or switch view
    // setTimeout(() => {
    //   window.location.href = "https://mellowenclave.com";
    // }, 150);
  };

  return (
    <div
      style={{
        textAlign: "center",
        whiteSpace: "pre-line",
        fontFamily: "'Playfair Display', serif",
        color: "#121212",
        padding: "1.5rem 2rem",
        backgroundColor: "#f9f7f3",
        border: "2px solid #D4AF37",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(212, 175, 55, 0.3)",
        maxWidth: "320px",
        margin: "0 auto",
        fontSize: "1.1rem",
        lineHeight: "1.5",
      }}
    >
      Membership application submitted!
      {"\n\n"}
      <strong style={{ color: "#D4AF37" }}>Be aware:</strong> we require the
      name of your sponsor.
      {"\n\n"}Thanks for Applying.
      {"\n"}Mellow Enclave
      <div style={{ marginTop: "2rem" }}>
        <button
          onClick={handleOk}
          style={{
            fontFamily: "'Playfair Display', serif",
            fontWeight: "700",
            fontSize: "1.05rem",
            color: "#121212",
            backgroundColor: "#D4AF37",
            border: "none",
            padding: "0.5rem 1.75rem",
            borderRadius: "30px",
            cursor: "pointer",
            boxShadow: "0 3px 6px rgba(0,0,0,0.15)",
            transition: "background-color 0.3s ease",
            userSelect: "none",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#b89029")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "#D4AF37")
          }
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default MembershipToast;
